import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";

const TypePrice = (props) => {
  const { type } = props;
  return (
    <Card {...props} sx={{ height: '100%' }}>
      <CardContent>
        <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12}>
            <Typography color="textSecondary" gutterBottom variant="h6" sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}>
              INSTANCE CREDITS
            </Typography>
            <Typography color="textPrimary" variant="h3" sx={{ fontSize: { xs: '1.6rem', sm: '2rem' } }}>
              {type}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default TypePrice;